import React, {PureComponent} from "react";
import {embedDashboard} from "superset-embedded-sdk";
import "./SupersetDemo.css";
import styled from 'styled-components';
import ComponentTitle from '../ComponentTitle';
import UpdatedDate from '../UpdatedDate';

const StyledMissingComponent = styled.div`
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
`;

const StyledMissingPlotWrapper = styled.div`
  border-radius: 5px;
  background: white;
  padding: 10px 10px 35px 10px;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  overflow: hidden;
`;

const SupersetContainer = styled.div`
  color: #42515a;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  ${props => {
    if (!props.heightInPx) {
      props.heightInPx = 500;
    }
    return `height: ${props.heightInPx}px;`;
  }} display: grid;
  justify-items: center;
  align-items: center;
  align-content: center;
`;

class SupersetDemo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      guestToken: null,
      supersetUrl: null
    };
  }

  componentDidMount() {
    this.fetchGuestToken();
  }

  async fetchGuestToken() {
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(JSON.parse(this.props.data))
    };

    try {
      const response = await fetch(`/api/v1/fetch-embed-token/`, requestOptions);
      const { token, supersetUrl } = await response.json();
      this.setState({guestToken: token, supersetUrl: supersetUrl});
    } catch (error) {
      console.error(error);
    }
  }

  getDashboardId() {
    const dataParsed = JSON.parse(this.props.data);
    return dataParsed.supersetDashboard.id;
  }
  containerId() {
    return `dashboard-container-${this.getDashboardId()}`;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.guestToken && this.state.guestToken !== prevState.guestToken) {
      const container = document.getElementById(this.containerId());

      embedDashboard({
        id: this.getDashboardId(),
        supersetDomain: this.state.supersetUrl,
        mountPoint: container,
        fetchGuestToken: () => this.state.guestToken,
        dashboardUiConfig: {
          hideTitle: true,
          filters: {
            visible: false
          }
        }
      });
    }
  }

  render() {
    return (
      <StyledMissingComponent columns={this.props.columns}>
        <ComponentTitle title={this.props.title} info={this.props.info} />
        <StyledMissingPlotWrapper>
          <SupersetContainer
            id={this.containerId()}
            columns={this.props.columns}
            heightInPx={this.props.heightInPx}
          />
          <UpdatedDate>{`letztes Update: ${this.props.lastUpdated}`}</UpdatedDate>
        </StyledMissingPlotWrapper>
      </StyledMissingComponent>
    );
  }
}

export default SupersetDemo;
